import { render, staticRenderFns } from "./Chart.vue?vue&type=template&id=8ec59642&"
import script from "./Chart.vue?vue&type=script&lang=ts&"
export * from "./Chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/riverline/optincollect-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ec59642')) {
      api.createRecord('8ec59642', component.options)
    } else {
      api.reload('8ec59642', component.options)
    }
    module.hot.accept("./Chart.vue?vue&type=template&id=8ec59642&", function () {
      api.rerender('8ec59642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/statistic/Chart.vue"
export default component.exports